const abbreviatedRank = {
  Freshman: 'FR',
  Sophomore: 'SO',
  Junior: 'JR',
  Senior: 'SR',
  'RedShirt Freshman': 'RS-FR',
  RedShirt_Freshman: 'RS-FR',
  'RedShirt Sophomore': 'RS-SO',
  RedShirt_Sophomore: 'RS-SO',
  'RedShirt Junior': 'RS-JR',
  RedShirt_Junior: 'RS-JR',
  'RedShirt Senior': 'RS-SR',
  RedShirt_Senior: 'RS-SR',
} as const;

export const getAbbreviatedClassRank = (
  type: keyof typeof abbreviatedRank | string,
) => abbreviatedRank[type as keyof typeof abbreviatedRank] || '';
